import { Routes } from '@angular/router';
import { canActivate } from '../core/guards/auth-guard';
import { documentResolver } from './pages/document/resolver/document.resolver';

export const routes: Routes = [
  {
    path: 'documents',
    canActivate: [canActivate],
    loadComponent: () => import('./pages/documents/documents').then((m) => m.Documents),
  },
  {
    path: 'document/:id',
    canActivate: [canActivate],
    resolve: {
      document: documentResolver,
    },
    loadComponent: () => import('./pages/document/document').then((m) => m.Document),
  },
  {
    path: 'forbidden',
    pathMatch: 'full',
    loadComponent: () => import('./pages/auth/forbidden/forbidden').then((m) => m.ForbiddenComponent),
  },
  {
    path: 'login',
    pathMatch: 'full',
    loadComponent: () => import('./pages/auth/login/login').then((m) => m.LoginComponent),
  },
  { path: '', pathMatch: 'full', redirectTo: 'documents' },
];
